import style from "./Home.module.scss";
import { useNavigate } from "react-router-dom";

import { useEffect } from "react";
export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    // Your logic here
    navigate("/login", { replace: true });
  }, []);

  return <></>;
}
